// client/src/components/Footer.jsx
import React from 'react';

function Footer() {
  return (
    <footer id="footer" style={styles.footer}>
      <p>&copy; {new Date().getFullYear()} Sua Empresa. Todos os direitos reservados.</p>
    </footer>
  );
}

const styles = {
  footer: {
    textAlign: 'center',
    backgroundColor: '#000',
    color: '#fff',
    padding: '1rem'
  }
};

export default Footer;
